import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher_get, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";

export class PaymentMethodAPI{
    query_dispatcher: QueryDispatcher
    sync_command_dispatcher: CommandDispatcher
    async_command_dispatcher: CommandDispatcher
    constructor(){
        this.query_dispatcher = query_dispatcher_get
        this.sync_command_dispatcher = sync_command_dispatcher
        this.async_command_dispatcher = async_command_dispatcher
    }
    
    async savePaymentMethod(args: object): Promise<any> {
        try{
            const res = await this.sync_command_dispatcher.dispatch('save.payment.method', args);
            return res
        }catch(error){
            console.log(error)
            return null
        }
    }

    async deletePaymentMethods(args: object): Promise<any> {
        try{
            const res = await this.sync_command_dispatcher.dispatch('delete.payment.methods', args);
            return res
        }catch(error){
            console.log(error)
            return null
        }
    }

    async getPaymentMethodsByCompanyDB(args: object): Promise<any> {
        try{
            const res = await this.sync_command_dispatcher.dispatch('get.payment.methods.by.companydb', args);
            return res.output
        }catch(error){
            console.log(error)
            return null
        }
    }
}